"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TabularAnalyticsController_1 = __importDefault(require("../modules/controllers/TabularAnalyticsController"));
let ColumnTree = class ColumnTree extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.TABULAR_ANALYTICS_CONTROLLER = TabularAnalyticsController_1.default.getInstance();
    }
    get internal_theme() {
        return this.theme || this.$theme.current.value;
    }
    get myDepth() {
        var _a;
        return (_a = this.depth) !== null && _a !== void 0 ? _a : 0;
    }
    onToggle(parent, child) {
        var _a;
        if (!child) {
            // Nivel 1 toggled
            // Si se activó este nodo, desactiva los demás antes de hacer cualquier otra cosa
            if (parent.checked) {
                this.deactivateOtherBranches(parent);
            }
            // Luego sincroniza hijos
            if ((_a = parent.children) === null || _a === void 0 ? void 0 : _a.length) {
                parent.children.forEach(c => {
                    var _a;
                    c.checked = parent.checked;
                    this.$emit('toggle', c, parent.checked);
                    if ((_a = c.children) === null || _a === void 0 ? void 0 : _a.length) {
                        c.children.forEach(grand => {
                            grand.checked = parent.checked;
                            this.$emit('toggle', grand, parent.checked);
                        });
                    }
                });
            }
        }
        else {
            // Nivel 2 o 3 toggled
            this.syncParentsUpwards(parent);
        }
        this.$emit('toggle', child !== null && child !== void 0 ? child : parent, (child !== null && child !== void 0 ? child : parent).checked);
    }
    deactivateOtherBranches(activeNode) {
        var _a;
        for (const node of this.tree) {
            if (node !== activeNode) {
                if (node.checked) {
                    node.checked = false;
                    this.$emit('toggle', node, false);
                }
                (_a = node.children) === null || _a === void 0 ? void 0 : _a.forEach(child => {
                    var _a;
                    if (child.checked) {
                        child.checked = false;
                        this.$emit('toggle', child, false);
                    }
                    (_a = child.children) === null || _a === void 0 ? void 0 : _a.forEach(grandChild => {
                        if (grandChild.checked) {
                            grandChild.checked = false;
                            this.$emit('toggle', grandChild, false);
                        }
                    });
                });
            }
        }
    }
    syncParentState(parent) {
        if (!parent.children)
            return;
        parent.checked = parent.children.some(c => c.checked);
    }
    syncParentsUpwards(node) {
        this.syncParentState(node);
        const parent = this.findParent(this.tree, node);
        if (parent) {
            this.syncParentsUpwards(parent);
        }
    }
    findParent(nodes, target) {
        var _a;
        for (const node of nodes) {
            if ((_a = node.children) === null || _a === void 0 ? void 0 : _a.includes(target)) {
                return node;
            }
            else if (node.children) {
                const found = this.findParent(node.children, target);
                if (found)
                    return found;
            }
        }
        return null;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ColumnTree.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: () => [] })
], ColumnTree.prototype, "tree", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], ColumnTree.prototype, "depth", void 0);
ColumnTree = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Separator: bmk_ui_framework_1.Separator },
        emits: ['toggle']
    })
], ColumnTree);
exports.default = ColumnTree;
